// lucideRegistry.ts
// Registre central des icônes Lucide disponibles dans l'application.
// C'est ici qu'on ajoute les nouvelles icônes Lucide au fur et à mesure.

import {
  Monitor,
  Settings,
  RefreshCw,
  Eye,
  EyeOff,
  Plus,
  Trash2,
  Mail,
  Pencil,
  X,
  Check,
  BookUser,
  ChevronDown,
  User,
  Minus,
  Play,
  Pause,
  Volume2,
  VolumeX,
  Image as ImageIcon,
  ArrowRightCircle,
  Layers,
  SplitSquareHorizontal,
  Circle,
  ZoomIn,
  Zap,
  Columns3,
  Clock,
  Grid3x3,
  ChartColumn
  // → Ajouter ici toute nouvelle icône Lucide nécessaire
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const lucideIcons: Record<string, LucideIcon> = {
  Monitor,
  Settings,
  RefreshCw,
  Eye,
  EyeOff,
  Plus,
  Trash2,
  Mail,
  Pencil,
  X,
  Check,
  image: ImageIcon,
  BookUser,
  ChevronDown,
  User,
  Minus,
  Play,
  Pause,
  Volume2,
  VolumeX,
  ArrowRightCircle,
  Layers,
  SplitSquareHorizontal,
  Circle,
  ZoomIn,
  Zap,
  Columns3,
  Clock,
  Grid3x3,
  ChartColumn
};